/**
 * Stripe Urgency - Dynamic Banner Updates
 * Subscribes to variant change events and updates urgency banners accordingly
 * Also handles countdown timer for flash sale banners
 */

class StripeUrgencyManager {
  constructor() {
    this.urgentStockAlert = document.querySelector('[data-stripe-urgency="urgent_stock_alert"]');
    this.lowStockWarning = document.querySelector('[data-stripe-urgency="low_stock_warning"]');
    this.inventoryDataElement = document.querySelector('#VariantInventoryData');
    this.countdownBanner = document.querySelector('[data-stripe-urgency="countdown_flash_sale"]');
    this.countdownInterval = null;
    
    this.init();
  }

  init() {
    // Subscribe to variant change events
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
    }
    
    // Initialize countdown if banner exists
    this.initCountdown();
  }

  handleVariantChange(event) {
    const variant = event?.data?.variant;
    if (!variant || !this.inventoryDataElement) return;

    const inventoryData = JSON.parse(this.inventoryDataElement.textContent);
    const qty = inventoryData[variant.id];

    this.updateUrgentStockAlert(qty);
    this.updateLowStockWarning(qty);
  }

  updateUrgentStockAlert(qty) {
    if (!this.urgentStockAlert) return;

    // Show if stock <= 10 and > 0
    if (typeof qty !== 'undefined' && qty > 0 && qty <= 10) {
      this.urgentStockAlert.style.display = '';
    } else {
      this.urgentStockAlert.style.display = 'none';
    }
  }

  updateLowStockWarning(qty) {
    if (!this.lowStockWarning) return;

    // Show if stock <= 3 and > 0
    if (typeof qty !== 'undefined' && qty > 0 && qty <= 3) {
      // Update the text with current quantity
      const textElement = this.lowStockWarning.querySelector('.stripe-urgency__text');
      if (textElement) {
        textElement.textContent = `Only ${qty} products left`;
      }
      this.lowStockWarning.style.display = '';
    } else {
      this.lowStockWarning.style.display = 'none';
    }
  }

  initCountdown() {
    if (!this.countdownBanner) return;
    
    const endDateStr = this.countdownBanner.dataset.countdownEnd;
    if (!endDateStr) return;
    
    const endDate = new Date(endDateStr).getTime();
    
    // Initial update
    this.updateCountdown(endDate);
    
    // Update every second
    this.countdownInterval = setInterval(() => {
      this.updateCountdown(endDate);
    }, 1000);
  }

  updateCountdown(endDate) {
    const now = new Date().getTime();
    const distance = endDate - now;
    
    // If countdown is finished, hide the banner
    if (distance < 0) {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      if (this.countdownBanner) {
        this.countdownBanner.style.display = 'none';
      }
      return;
    }
    
    // Calculate time units
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    // Update DOM elements
    const daysEl = this.countdownBanner.querySelector('[data-countdown-days]');
    const hoursEl = this.countdownBanner.querySelector('[data-countdown-hours]');
    const minutesEl = this.countdownBanner.querySelector('[data-countdown-minutes]');
    const secondsEl = this.countdownBanner.querySelector('[data-countdown-seconds]');
    
    if (daysEl) daysEl.textContent = this.padZero(days);
    if (hoursEl) hoursEl.textContent = this.padZero(hours);
    if (minutesEl) minutesEl.textContent = this.padZero(minutes);
    if (secondsEl) secondsEl.textContent = this.padZero(seconds);
  }

  padZero(num) {
    return num < 10 ? '0' + num : num;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new StripeUrgencyManager());
} else {
  new StripeUrgencyManager();
}
